export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-10">
          <div className="lg:w-[360px] shrink-0">
            <span className="text-2xl font-bold font-heading text-primary-400 whitespace-nowrap">
              糖心视频
            </span>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300">
              糖心视频网聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等热门平台资源，为您提供最新电影、电视剧、综艺节目的高清免费在线观看服务。每日更新，不缓冲流畅追剧，打造一站式影视娱乐体验。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-6">
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3 whitespace-nowrap">快速导航</h4>
              <ul className="space-y-2">
                <li><a href="#hero" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a></li>
                <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选专题</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a></li>
                <li><a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3 whitespace-nowrap">内容分类</h4>
              <ul className="space-y-2">
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">电影</a></li>
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">电视剧</a></li>
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">综艺</a></li>
                <li><a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">动漫</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3 whitespace-nowrap">服务支持</h4>
              <ul className="space-y-2">
                <li><a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a></li>
                <li><a href="#about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3 whitespace-nowrap">合作伙伴</h4>
              <p className="text-sm text-foreground-500">
                敬请期待合作入驻
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 糖心视频网 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            聚合西瓜视频·樱花视频·糖豆视频·樱桃视频 热门影视资源
          </p>
        </div>
      </div>
    </footer>
  );
}